<template>
  <div class="modal__overlay" @click.stop="toggleMenu()">
    <div class="modal" @click.stop="">
      <div class="user-name">{{ `${user.firstName} ${user.lastName}` }}</div>
      <div class="actions">
        <span><i class="material-icons">settings</i>Ajustes</span>
        <span class="logOut" @click="logout"><i class="material-icons">logout</i>Cerrar sesión</span>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, computed } from "@vue/runtime-core";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup(_, { emit }) {
    const router = useRouter();
    const store = useStore();
    const userMenuActive = inject("userMenuActive");
    const user = computed(() => store.getters.manageUser_user);

    function toggleMenu() {
      emit("closeUserMenu");
    }

    async function logout() {
      await store.dispatch("manageUser_disabled");
      router.push("/login");
      userMenuActive.value = false;
    }

    return {
      toggleMenu,
      logout,
      user
    };
  },
};
</script>

<style lang="scss" scoped>
.modal__overlay {
  display: block;
  background-color: transparent;
  .modal {
    position: fixed;
    max-width: 200px;
    height: 188px;
    top: 55px;
    right: 0;
    margin: 0;
    padding: 8px;
    display: flex;
    flex-direction: column;
    
    font-size: 16px;
    color: $gray;
    border-radius: 0;
    box-shadow: -2px 3px 3px 0px rgb(0 0 0 / 24%);
    .user-name {
      padding: 20px 0;
      border-bottom: 1px solid rgba(96, 96, 96, 0.3);
      font-family: $font-palanquin;
    }
    .actions {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      padding-left: 15px;
      span {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        .material-icons {
          position: static;
          color: $gray;
        }
      &:first-child{
        opacity: .5;
        cursor: default;
        i{
          cursor: default;
        }
      }
      }
    }
  }
}

.logOut {
  i {
    transform: rotate(180deg);
  }
}
</style>